import { render, staticRenderFns } from "./posShift.vue?vue&type=template&id=071814e2&scoped=true&"
import script from "./posShift.vue?vue&type=script&lang=js&"
export * from "./posShift.vue?vue&type=script&lang=js&"
import style0 from "./posShift.vue?vue&type=style&index=0&id=071814e2&prod&scoped=true&lang=css&"
import style1 from "./posShift.vue?vue&type=style&index=1&id=071814e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071814e2",
  null
  
)

export default component.exports